import * as actionTypes from "../actionTypes/Index";
import { accessControlUsersInitialState } from "./InitialState";
import { IActionType } from "../../interfaces/Index";

const initialState = { ...accessControlUsersInitialState };

export const appendUpdateAccessControlUsers = (payload: any, state: any) => {
  if (payload.isPaginatedRes) {
    return [...state.accessControlUsers, ...payload.accessControlUserData];
  }
  return payload.accessControlUserData.slice();
};

export default function accessControlUserReducer(
  state = initialState,
  action: IActionType
) {
  switch (action.type) {
    case actionTypes.CREATE_ACCESS_CONTROL_USERS_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        isAccessControlUserAdded: false,
        error: null,
      });
    }
    case actionTypes.CREATE_ACCESS_CONTROL_USERS_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        isAccessControlUserAdded: true,
        accessControlUserDetailsNew: null,
      });
    }
    case actionTypes.CREATE_ACCESS_CONTROL_USERS_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        isAccessControlUserAdded: false,
        error: action.error,
      });
    }
    case actionTypes.GET_ACCESS_CONTROL_USERS_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        isAccessControlUserUpdated: false,
        isAccessControlUserAdded: false,
        error: null,
      });
    }
    case actionTypes.GET_ACCESS_CONTROL_USERS_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        accessControlUsers: appendUpdateAccessControlUsers(
          action.payload,
          state
        ),
        pagination: (action.payload! as any).pagination,
      });
    }
    case actionTypes.GET_ACCESS_CONTROL_USERS_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        accessControlUsers: null,
        error: action.error,
      });
    }
    case actionTypes.GET_ACCESS_CONTROL_USER_DETAIL_V2_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        isaccessControlUserDetailsNewFetched: false,
        accessControlUserDetailsNew: null,
        error: null,
      });
    }
    case actionTypes.GET_ACCESS_CONTROL_USER_DETAIL_V2_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        isaccessControlUserDetailsNewFetched: true,
        accessControlUserDetailsNew: action.payload,
      });
    }
    case actionTypes.GET_ACCESS_CONTROL_USER_DETAIL_V2_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        isaccessControlUserDetailsNewFetched: false,
        error: action.error,
      });
    }
    case actionTypes.UPDATE_ACCESS_CONTROL_USERS_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        isAccessControlUserUpdated: false,
        error: null,
      });
    }
    case actionTypes.UPDATE_ACCESS_CONTROL_USERS_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        isAccessControlUserUpdated: true,
        accessControlUserDetailsNew: null,
      });
    }
    case actionTypes.UPDATE_ACCESS_CONTROL_USERS_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        isAccessControlUserUpdated: false,
        error: action.error,
      });
    }
    case actionTypes.GET_ALL_CLIENT_ROLES_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        isAllClientsRolesFetched: false,
        allClientsRoles: null,
        error: null,
      });
    }
    case actionTypes.GET_ALL_CLIENT_ROLES_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        isAllClientsRolesFetched: true,
        allClientsRoles: action.payload,
      });
    }
    case actionTypes.GET_ALL_CLIENT_ROLES_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        isAllClientsRolesFetched: false,
        allClientsRoles: null,
        error: action.error,
      });
    }
    case actionTypes.FETCH_ALL_FILTERS_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        isAllFiltersFetched: false,
        filters: null,
        error: null,
      });
    }
    case actionTypes.FETCH_ALL_FILTERS_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        isAllFiltersFetched: true,
        filters: action.payload,
      });
    }
    case actionTypes.FETCH_ALL_FILTERS_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        isAllFiltersFetched: false,
        filters: null,
        error: action.error,
      });
    }
    default:
      return state;
  }
}
